import { useT } from "../../../../i18n";
import { Button, Tooltip } from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import FoundationIcon from "@mui/icons-material/Foundation";
import {
  emptyFuhrparkeintragWithOutAnbauteile,
  emptyMaterialanfuhr,
  MaterialTransportDaten,
} from "../../../../models/taetigkeitsberichte/models";
import { NeuerMaterialTtbExternButtonProps } from "./MaterialButtonProps";

export default function NeuerMaterialanfuhrTtbExternButton({
  push,
}: NeuerMaterialTtbExternButtonProps) {
  const { t } = useT("fuhrpark");

  const handleAddMaterialanfuhr = async () => {
    const emptyFuhrparkeintrag = structuredClone(
      emptyFuhrparkeintragWithOutAnbauteile
    );
    emptyFuhrparkeintrag.materialanfuhr.push(
      emptyMaterialanfuhr as MaterialTransportDaten
    );

    push(emptyFuhrparkeintrag);
  };

  return (
    <Tooltip title={t("material-delivery")} arrow>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleAddMaterialanfuhr}
      >
        <CategoryIcon />
        <KeyboardDoubleArrowRightIcon />
        <FoundationIcon />
      </Button>
    </Tooltip>
  );
}
